module.exports = __webpack_public_path__ + "resource/img/image025.a49b4287.png";